import React from 'react';
import ReactOnRails from 'react-on-rails';
import WorksheetsControls from './worksheets-controls';
import WorksheetDitto from './worksheet-ditto';
import WorksheetAnswers from './worksheet-answers';

import {
  worksheetProblems,
  typeFromURL,
  limitsFromPlaces
} from './lib/math';

const qtyProblems = 16;
const sheetPlaces = 1;

export default class Worksheets extends React.Component {

  constructor(props) {
    super(props);
    const problems = this.setProblems(sheetPlaces, qtyProblems, typeFromURL());
    this.state = {
      sheetType: typeFromURL(),
      sheetPlaces: sheetPlaces,
      qtyProblems: qtyProblems,
      problems: problems,
      correctProblems: this.correctArray()
    };
    this.chooseType.bind(this);
    this.choosePlaces.bind(this);
  }

  setProblems(sheetPlaces, qty, type) {
    const limits = limitsFromPlaces(sheetPlaces);
    const problems = worksheetProblems(type, qty, limits[0], limits[1]);
    return problems;
  }

  correctArray() {
    let correctProblems = new Array(qtyProblems);
    for (var i = 0; i < correctProblems.length; ++i) {
      correctProblems[i] = 0;
    }
    return correctProblems;
  }

  choosePlaces(number) {
    this.setState({
      sheetPlaces: number,
      correctProblems: this.correctArray(),
      problems: this.setProblems(number, qtyProblems, this.state.sheetType)
    });
  }

  chooseType(type) {
    this.setState({
      sheetType: type,
      correctProblems: this.correctArray(),
      problems: this.setProblems(this.state.sheetPlaces, qtyProblems, type)
    });
  }

  setCorrectProblem(index, result) {
    let cp = this.state.correctProblems;
    cp[index] = result;
    this.setState({
      correctProblems: cp
    });
  }

  render() {
    return(
      <div className="worksheets">
        <div className="worksheets__name">
          Name:
        </div>
        <div className="worksheets__date">
          Date:
        </div>
        <div className="row">
          <div className="col-sm-3 col-xs-12">
            <WorksheetsControls
              sheetType={this.state.sheetType}
              sheetPlaces={this.state.sheetPlaces}
              chooseType={this.chooseType.bind(this)}
              choosePlaces={this.choosePlaces.bind(this)}
               />
          </div>
          <div className="col-sm-9 col-xs-12">
            <WorksheetDitto
              sheetType={this.state.sheetType}
              problems={this.state.problems}
              correctProblems={this.state.correctProblems}
              setCorrectProblem={this.setCorrectProblem.bind(this)}
            />
          </div>
          <WorksheetAnswers
            problems={this.state.problems}
            />
        </div>
      </div>
    );
  }

}

ReactOnRails.register({ Worksheets });



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/worksheets/component.js
 **/